import { WSAlertProps } from "@wingspanhq/fe-component-library";
import { PropsWithChildren } from "react";
import { useHistory } from "react-router-dom";
import {
  AnyNotificationContext,
  NotificationHandleType
} from "../../Notifications";
import { BankingFailed } from "./BankingFailed";
import { BankingVerified } from "./BankingVerified";
import { TaxVerified } from "./TaxVerified";
import { RequirementsApprovedPayee } from "./RequirementsApprovedPayee";
import { RequirementsCompletePayee } from "./RequirementsCompletePayee";
import { RequirementsReRequestedPayee } from "./RequirementsReRequestedPayee";
import { RequirementsRejectedPayee } from "./RequirementsRejectedPayee";
import { RequirementsAwaitingReviewPayee } from "./RequirementsAwaitingReviewPayee";
import { NotificationWithGroup } from "../../../selectors/selectorAlerts";
import { GenericRequirementNotificationContext } from "./helper";

export interface NotificationAlertOverride<C extends AnyNotificationContext> {
  (
    notification: NotificationWithGroup<C>,
    history: ReturnType<typeof useHistory>
  ): Partial<PropsWithChildren<WSAlertProps>>;
}

export const notificationAlertOverridesMap: Partial<
  Record<
    NotificationHandleType,
    | NotificationAlertOverride<GenericRequirementNotificationContext>
    | NotificationAlertOverride<AnyNotificationContext>
  >
> = {
  [NotificationHandleType.BankingFailed]: BankingFailed,
  [NotificationHandleType.BankingVerified]: BankingVerified,
  [NotificationHandleType.TaxVerified]: TaxVerified,
  [NotificationHandleType.RequirementsApprovedPayee]: RequirementsApprovedPayee,
  [NotificationHandleType.RequirementsCompletePayee]: RequirementsCompletePayee,
  [NotificationHandleType.RequirementsReRequestedPayee]:
    RequirementsReRequestedPayee,
  [NotificationHandleType.RequirementsRejectedPayee]: RequirementsRejectedPayee,
  [NotificationHandleType.RequirementsAwaitingReviewPayee]:
    RequirementsAwaitingReviewPayee
};
